/* eslint-disable react/require-default-props */
import Grid from '@mui/material/Grid2';

import { Outlet, useSearchParams } from "react-router-dom"
import { URL_PARAMS, DISP_MODE } from '../constants/constants'
import MainHeader from "../components/MainHeader"
import MainFooter from '../components/MainFooter';

export interface Props {
  bgcolor?:string;
}

export default function MainLayout(props:Props) {
  const [searchParams] = useSearchParams();
  const isPopupMode = !!(searchParams.get(URL_PARAMS.DISP_MODE) && searchParams.get(URL_PARAMS.DISP_MODE) === DISP_MODE.POPUP);

  return (
      <Grid
        container
        direction="column"
        justifyContent="flex-start"
        alignItems="stretch"
        sx={{height:"100vh",flexWrap:"nowrap" }}
      >
        { !isPopupMode &&
          <>
            <Grid sx={{flexGrow: 0}}>
              <MainHeader />
            </Grid>
            <Grid sx={{bgcolor:props.bgcolor,flexGrow: 1}}>
              <Outlet />
            </Grid>
            <Grid sx={{flexGrow: 0}}>
              <MainFooter />
            </Grid>
          </>
        }
        { isPopupMode &&
          <Grid sx={{bgcolor:props.bgcolor,flexGrow: 1}}>
            <Outlet />
          </Grid>
        }
      </Grid>

  )
}
